// M45b — Hook + context for the quick-access Invite modal. Lives
// outside InviteProvider.tsx so that file can satisfy
// react-refresh/only-export-components by exporting only the provider
// component (same split pattern as `useFeedback.ts` + M32
// `FeedbackProvider.tsx`).
//
// Usage from anywhere inside <InviteProvider>:
//   const { open } = useInvite();
//   <IconButton onClick={() => open()} aria-label="Invite a friend" />
//
// The modal handles its own data fetch (calls
// `getOrCreateMyReferralCode`) when `open === true`, so callers don't
// need to pre-fetch.
import { createContext, useContext } from 'react';

export interface InviteContextValue {
  open: () => void;
  close: () => void;
}

export const InviteContext = createContext<InviteContextValue | undefined>(undefined);

export function useInvite(): InviteContextValue {
  const ctx = useContext(InviteContext);
  if (!ctx) throw new Error('useInvite must be used within InviteProvider');
  return ctx;
}
